export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=408c272dab935c7afc071f5a5123a700214767c478&name=revalidateCommunity!'